// needs to be aligned with VIP_USERS constant in AffiliateConstants.java
export const VIP_USERS = [
  "lubos",
  "tphyp",
  "suy1s",
  "7xikt",
  "fctnw",
  "wupik",
  "pbpah",
  "rze28",
  "60hhc",
  "pmq85",
  "o0jf1"];
